export default __webpack_public_path__ + "assets/front/scss/classification-browsing.85d0d8d8f92992fec94898ee2f0de619.css";